import { render, staticRenderFns } from "./GeneralInformationTab.vue?vue&type=template&id=7d863af0&scoped=true"
import script from "./GeneralInformationTab.vue?vue&type=script&lang=js"
export * from "./GeneralInformationTab.vue?vue&type=script&lang=js"
import style0 from "./GeneralInformationTab.vue?vue&type=style&index=0&id=7d863af0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d863af0",
  null
  
)

export default component.exports